import IUser from "../interfaces/user";
import decryptData from "./decryption";
import { ILcdData } from "../interfaces/redux";
import * as jwt from "jsonwebtoken";

export function getToken() {
  const storeitem = decryptData(
    JSON.parse(localStorage.getItem("loginData") || "{}")
  );
  let apitoken = "";
  // console.log("hee;lo >", storeitem)
  if (storeitem !== null) {
    apitoken = storeitem.token;
  }
  return apitoken;
}

export function checkUserAccessAndToken(accessArray: Array<number>) {
  let token = getToken();
  if (token) {
    try {
      let validateToken = jwt.verify(
        token,
        process.env.REACT_APP_JWTSECRET || ""
      ) as any;
      if (validateToken.id) {
        let userType = getUserType();
        // console.log("User Type >>", userType)
        if (typeof userType === "number" && accessArray.includes(userType)) {
          return token;
        }
      }
    } catch (error) {
      return false;
    }
  }
}

function getUserType() {
  const storeitem = decryptData(
    JSON.parse(localStorage.getItem("loginData") || "{}")
  );
  let userType = "";
  if (storeitem !== null) {
    userType = storeitem?.user.hasOwnProperty("user_type")
      ? storeitem.user.user_type
      : "";
  }
  return userType;
}

//add code if token not found then do logout
export function getHeaderForAxios() {
  const apiToken = getToken();
  const headers = apiToken
    ? { "Content-Type": "application/json", auth: apiToken }
    : { "Content-Type": "application/json", auth: "" };
  return headers;
}

export function getUserData(uuidOnly: boolean = true) {
  const storeitem = decryptData(
    JSON.parse(localStorage.getItem("loginData") || "{}")
  );
  let userData: IUser;
  if (storeitem !== null) {
    userData = storeitem.user;
    if (uuidOnly && userData) {
      return userData.uuid;
    }
    return userData;
  }
}

export function getActiveLcdData() {
  if (
    localStorage.getItem("alphaIdentifier") &&
    localStorage.getItem("lcdData")
  ) {
    const storeitem = decryptData(
      JSON.parse(localStorage.getItem("alphaIdentifier") || "")
    );
    const storeLcdItem = decryptData(
      JSON.parse(localStorage.getItem("lcdData") || "{}")
    );
    if (storeitem !== null && storeLcdItem !== null) {
      const indexOfItem = storeLcdItem.findIndex((item: ILcdData) => {
        return item.alphacode_identifier === storeitem.toString();
      });
      if (indexOfItem !== -1) {
        return { data: storeLcdItem, lcd: storeitem, index: indexOfItem };
      }
      //return { "data": "", "lcd": "", "index": -1 };
    }
  }
  return { data: "", lcd: "", index: -1 };
}

export function getOnlyActiveLcdData() {
  if (
    localStorage.getItem("alphaIdentifier") &&
    localStorage.getItem("lcdData")
  ) {
    const storeitem = decryptData(
      JSON.parse(localStorage.getItem("alphaIdentifier") || "")
    );
    const storeLcdItem = decryptData(
      JSON.parse(localStorage.getItem("lcdData") || "{}")
    );
    if (storeitem !== null && storeLcdItem !== null) {
      const indexOfItem = storeLcdItem.findIndex((item: ILcdData) => {
        return item.alphacode_identifier === storeitem.toString();
      });
      if (indexOfItem !== -1) {
        return { data: storeLcdItem[indexOfItem] };
      }
      //return { "data": "", "lcd": "", "index": -1 };
    }
  }
  return { data: {} };
}

export function getSelectedDealBySponsor() {
  let data = {};
  if (localStorage.getItem("selectedDealBySponsor")) {
    const storeitem = decryptData(
      JSON.parse(localStorage.getItem("selectedDealBySponsor") || "")
    );
    if (storeitem !== null) {
      data = storeitem;
    }
  }
  console.log("Selected Deal >>", data);
  return data;
}

export function getSelectedOptions() {
  let data = {};
  if (localStorage.getItem("selectedOptions")) {
    const storeitem = decryptData(
      JSON.parse(localStorage.getItem("selectedOptions") || "")
    );
    if (storeitem !== null) {
      data = storeitem;
    }
  }
  console.log("Selected Data >>", data);
  return data;
}

export function getSelectedSponsorByStore() {
  let data = "";
  if (localStorage.getItem("selectedSponsorByStore")) {
    const storeitem = decryptData(
      JSON.parse(localStorage.getItem("selectedSponsorByStore") || "")
    );
    if (storeitem !== null) {
      data = storeitem;
    }
  }
  return data;
}

export function getSelectedLanguageOptions() {
  let data = process.env.REACT_APP_LANGUAGE_CODE || "en";
  if (localStorage.getItem("selectedLanguage")) {
    const storeitem = decryptData(
      localStorage.getItem("selectedLanguage") || ""
    );
    if (storeitem !== null) {
      data = storeitem;
    }
  }
  return data;
}

export function displayIntroVideo() {
  let data = "";
  const isVideoAlreadyDisplayed = localStorage.getItem("intoVideoDisplayed")
    ? decryptData(localStorage.getItem("intoVideoDisplayed") || "")
    : false;
  if (
    localStorage.getItem("displayIntro") &&
    localStorage.getItem("intoVideoIdentifier") &&
    !isVideoAlreadyDisplayed
  ) {
    const storeVideoItem = decryptData(
      localStorage.getItem("intoVideoIdentifier") || ""
    );
    const isDisplayVideo = decryptData(
      localStorage.getItem("displayIntro") || ""
    );
    if (
      storeVideoItem !== null &&
      isDisplayVideo !== null &&
      isDisplayVideo === true
    ) {
      data = storeVideoItem;
    }
  }
  return data;
}
